function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { brandListApi, productDetailApi } from '@/api/product';
import { mapGetters } from 'vuex';
import { pointsProductDetailApi } from '@/api/pointsMall';
var defaultObj = {
  image: '',
  sliderImages: [],
  videoLink: '',
  sliderImage: '',
  name: '',
  intro: '',
  keyword: '',
  couponList: [],
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  attrValue: [{
    image: '',
    price: 0,
    vipPrice: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    weight: 0,
    volume: 0,
    brokerage: 0,
    brokerageTwo: 0,
    barCode: ''
  }],
  attr: [],
  selectRule: '',
  isSub: false,
  content: '',
  specType: false,
  id: undefined,
  couponIds: [],
  coupons: [],
  postage: '1',
  categoryId: '',
  guaranteeIds: '',
  guaranteeIdsList: [],
  brandId: '',
  deliveryMethod: ''
};
//普通商品规格默认数据
var objTitle = {
  price: {
    title: '售价'
  },
  vipPrice: {
    title: '会员价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  brokerage: {
    title: '一级返佣(%)'
  },
  brokerageTwo: {
    title: '二级返佣(%)'
  }
};
//积分商品规格默认数据
var objTitlePoints = {
  price: {
    title: '兑换金额（元）'
  },
  redeemIntegral: {
    title: '兑换积分'
  },
  cost: {
    title: '市场价（元）'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};

// 积分商城默认规格数据
var defaultObjAttrValue = {
  image: '',
  price: 0.0,
  redeemIntegral: 1,
  cost: 0.0,
  stock: 0,
  barCode: '',
  weight: 0,
  volume: 0
};
export default {
  data: function data() {
    return {
      manyTabTit: {},
      manyTabDate: {},
      formValidate: Object.assign({}, defaultObj),
      labelarr: [],
      ruleList: [],
      merCateList: [],
      // 商户分类筛选
      shippingList: [],
      // 运费模板
      formThead: Object.assign({}, objTitle),
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      brandList: [],
      search: {
        limit: 9999,
        page: 1,
        cid: '',
        brandName: ''
      },
      loading: false,
      attrInfo: {},
      tempRoute: {},
      videoLink: '',
      fullscreenLoading: false,
      //积分商品
      dialogVisibleInfo: false,
      // 控制积分、商品详情抽屉展示
      attrValue: [] //商品规格
      // componentKey: 0,
      // isShow: false, //控制商品详情展示
      // productId: 0, //商品id，普通、活动商品都是此id
    };
  },
  computed: _objectSpread({}, mapGetters(['adminProductClassify', 'productBrand'])),
  methods: {
    // 解决cascader placeholder重影
    fixCascader: function fixCascader() {
      var cascader = document.querySelectorAll('.el-cascader__search-input');
      for (var index = 0; index < cascader.length; index++) {
        cascader[index].setAttribute('placeholder', '');
      }
    },
    //普通商品详情
    getProductInfo: function getProductInfo(id) {
      var _this = this;
      this.formThead = Object.assign({}, objTitle);
      this.loading = true;
      productDetailApi(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var obj;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this.getData(res);
                obj = Object.assign({}, defaultObj.attrValue[0]);
                delete obj.image;
                if (!res.isSub) {
                  delete obj.brokerage;
                  delete obj.brokerageTwo;
                }
                if (!res.isPaidMember) {
                  delete obj.vipPrice;
                }
                _this.attrValue = obj;
                _this.getbrandList();
                _this.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this.loading = false;
      });
    },
    // 积分商品详情
    getPointsProductInfo: function getPointsProductInfo(id) {
      var _this2 = this;
      this.formThead = Object.assign({}, objTitlePoints);
      this.getPointsProductAttrValue();
      this.fullscreenLoading = true;
      pointsProductDetailApi(id).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                // this.isAttr = true;
                _this2.getData(res);
                _this2.fullscreenLoading = false;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this2.fullscreenLoading = false;
      });
    },
    // 获取积分商品规格数据
    getPointsProductAttrValue: function getPointsProductAttrValue() {
      var obj = Object.assign({}, defaultObjAttrValue);
      delete obj.image;
      this.attrValue = obj;
    },
    // 商品详情数据
    getData: function getData(res) {
      var _this3 = this;
      var info = res;
      this.formValidate = _objectSpread(_objectSpread({}, info), {}, {
        image: this.$selfUtil.setDomain(info.image),
        sliderImages: JSON.parse(info.sliderImage),
        cateIds: info.cateId ? info.cateId.split(',').map(Number) : '',
        // 商品分类id
        couponList: info.couponList || [],
        //优惠券
        sort: info.sort ? info.sort : 0,
        attr: info.attr || [],
        attrValue: info.attrValue ? info.attrValue : [],
        content: info.content ? this.$selfUtil.replaceImgSrcHttps(info.content) : '',
        id: info.id ? info.id : 0,
        exchangeNum: info.exchangeNum || 0,
        isHot: info.isHot
      });
      this.labelarr = info.keyword ? info.keyword.split(',') : [];
      var imgs = JSON.parse(info.sliderImage);
      var imgss = [];
      Object.keys(imgs).map(function (i) {
        imgss.push(_this3.$selfUtil.setDomain(imgs[i]));
      });
      this.formValidate.sliderImages = [].concat(imgss);
      if (this.getFileType(this.formValidate.sliderImages[0]) == 'video') {
        //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
        this.$set(this, 'videoLink', this.formValidate.sliderImages[0]);
        this.formValidate.sliderImages.splice(0, 1);
      }
      if (info.specType) {
        //this.productGetRule(); //加载商品规格选项
        if (info.attrValue) {
          this.formValidate.attr = info.attr.map(function (item) {
            return {
              attrName: item.attrName,
              attrValue: item.attrValues.split(',')
            };
          });
          this.ManyAttrValue = info.attrValue;
          this.ManyAttrValue.forEach(function (val) {
            val.image = _this3.$selfUtil.setDomain(val.image);
            val.attrValue = JSON.parse(val.attrValue);
            _this3.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
          });
          /***多规格商品如果被删除过sku，优先展示api返回的数据,否则会有没有删除的错觉***/
          var manyAttr = this.attrFormat(this.formValidate.attr);
          if (manyAttr.length !== this.ManyAttrValue.length) {
            this.$set(this, 'showAll', true);
            this.isAttr = false;
          } else {
            this.isAttr = true;
          }
          /*******/
          var tmp = {};
          var tmpTab = {};
          this.formValidate.attr.forEach(function (o, i) {
            tmp[o.attrName] = {
              title: o.attrName
            };
            tmpTab[o.attrName] = '';
          });

          // 此处手动实现后台原本value0 value1的逻辑
          this.formValidate.attrValue.forEach(function (item) {
            for (var attrValueKey in item.attrValue) {
              item[attrValueKey] = item.attrValue[attrValueKey];
            }
          });
          this.manyTabTit = tmp;
          this.manyTabDate = tmpTab;
          this.formThead = Object.assign({}, this.formThead, tmp);
        } else {
          if (this.formValidate.attr.length) {
            this.oneFormBatch[0].image = this.$selfUtil.setDomain(info.image);
            this.formValidate.attr = info.attr.map(function (item) {
              return {
                attrName: item.attrName,
                attrValue: JSON.parse(item.attrValues)
              };
            });
          }
        }
      } else {
        this.OneattrValue = info.attrValue;
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
    // 品牌列表
    getbrandList: function getbrandList() {
      var _this4 = this;
      this.search.cid = this.formValidate.categoryId;
      brandListApi(this.search).then(function (res) {
        _this4.brandList = res.list;
        _this4.brandList.unshift({
          id: 0,
          name: '其他',
          isShow: true
        });
      });
    },
    watCh: function watCh(val) {
      var _this5 = this;
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.ManyAttrValue = this.attrFormat(val);
      this.ManyAttrValue.forEach(function (val, index) {
        var key = Object.values(val.attrValue).sort().join('/');
        if (_this5.attrInfo[key]) _this5.ManyAttrValue[index] = _this5.attrInfo[key];
      });
      this.attrInfo = [];
      this.ManyAttrValue.forEach(function (val) {
        _this5.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    vipPrice: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    weight: 0,
                    volume: 0,
                    brokerage: 0,
                    brokerageTwo: 0,
                    redeemIntegral: 1
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                vipPrice: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                weight: 0,
                volume: 0,
                brokerage: 0,
                brokerageTwo: 0,
                redeemIntegral: 1,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              // Object.values(res[kk].attrValue).forEach((v, i) => {
              //   res[kk]['value' + i] = v
              // })
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    },
    //详情关闭
    onCloseInfo: function onCloseInfo() {
      this.dialogVisibleInfo = false;
    }
  }
};